import { SUGGESTED_PACK } from 'enums';
import { EMPTY_STRING } from 'constants/general';
import { ActivityType } from 'interfaces/common.interface';
import { HabitEditSuggestionFormPatch } from 'interfaces/habit-edit-form.interface';
import {
  ExtendedSuggestion,
  Suggestion
} from 'interfaces/setting.interface';
import { normalizeDaysOfWeekValue } from 'utils/daysOfWeek.util';
import { hasCompletionRequirement } from 'utils/validators';

export const attachActivityToSuggestion = (
  suggestion: Suggestion,
  activityLibrary: ActivityType[],
  marketplaceActivities: ActivityType[]
): ExtendedSuggestion => {
  if (suggestion.where === SUGGESTED_PACK.CREATE_NEW_HABIT) {
    return suggestion;
  }

  const sourceActivities =
    suggestion.where === SUGGESTED_PACK.LIBRARY
      ? activityLibrary
      : marketplaceActivities;

  const activity = sourceActivities.find(
    (item) => item.name === suggestion.name
  );

  return { ...suggestion, activity };
};

export const getHabitEditFormPatchFromSuggestion = (
  suggestion: ExtendedSuggestion
): HabitEditSuggestionFormPatch => {
  if (
    suggestion.where === SUGGESTED_PACK.CREATE_NEW_HABIT ||
    !suggestion.activity
  ) {
    return { name: suggestion.name };
  }

  const activity = suggestion.activity;
  return {
    name: activity.name ?? suggestion.name,
    emoji: activity.habit_icon ?? EMPTY_STRING,
    durationSeconds: activity.duration_seconds ?? 0,
    completionValue: activity.completion_requirements,
    useTimer: !hasCompletionRequirement(activity),
    daysOfWeek: normalizeDaysOfWeekValue(activity.days_of_week)
  };
};
